import type { BetSpreadData, BetData } from "@/prematch/model/prematch-bet-spread";
import type { Event } from "@/shared/model/event";
import { GroupCode } from "@/shared/model/enums/group-code";
import { Side } from "@/shared/model/enums/side";

export default function usePrematchBetSpread() {
    const normalizeBetData = (betData: BetSpreadData, event: Event): BetData[] => {
        if (!event) return;

        const selectedMarket = event.groupedMarkets?.find(
            (market) => market.groupCode === GroupCode.Custom || market.groupCode == GroupCode.MatchResultNoOvertime,
        );

        if (!selectedMarket || !betData) {
            return null;
        }

        const homeTeamBet = (Number(betData["1"]) * 100).toFixed(1);
        const awayTeamBet = (Number(betData["2"]) * 100).toFixed(1);
        const drawBet = (Number(betData["X"]) * 100).toFixed(1);
        const statsData: BetData[] = selectedMarket.outcomes.map((outcome) => {
            let bet;
            let marketName;
            let teamName;

            switch (outcome.subType) {
                case "H":
                    bet = homeTeamBet;
                    marketName = "1";
                    teamName = event.teams.find((team) => team.side === Side.Home)?.name;
                    break;
                case "A":
                    bet = awayTeamBet;
                    marketName = "2";
                    teamName = event.teams.find((team) => team.side === Side.Away)?.name;
                    break;
                case "D":
                    bet = drawBet;
                    marketName = "X";
                    teamName = "Remíza";
                    break;
                default:
                    bet = null;
                    marketName = null;
            }
            return {
                outcome,
                bet,
                marketName,
                teamName,
            };
        });

        return statsData
            .filter((data) => data.bet)
            .toSorted((a, b) => b.outcome.subType.localeCompare(a.outcome.subType));
    };
    return {
        normalizeBetData,
    };
}
